import {Component, ComponentFactoryResolver, Inject, OnInit} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import { MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {finalize} from 'rxjs/operators';
import {PendingDoc} from 'src/app/models/pending-doc';
import {Document} from 'src/app/models/document';
import {DocumentService} from 'src/app/services/document.service';
import {PendingDocService} from 'src/app/services/pending-doc.service';
import {MemberService} from 'src/app/services/member.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-upload-document-dialog',
  templateUrl: './upload-document-dialog.component.html',
  styleUrls: [ './upload-document-dialog.component.scss' ]
})
export class UploadDocumentDialogComponent implements OnInit {

  public selectedFile: any = null;
  public allFiles: any[] = [];
  public isProofOfVaccine: boolean;
  public spinner: boolean;
  public pendingDoc: PendingDoc;

  constructor (
    public db: AngularFirestore,
    private fs: AngularFireStorage,
    public _documentService: DocumentService,
    public _pendinDocService: PendingDocService,
    public _memberService: MemberService,
    @Inject(MAT_DIALOG_DATA) public data: PendingDoc
  ) {
    this.pendingDoc = this.data
  //  console.log("pendingDoc " + JSON.stringify(this.pendingDoc))
  }

  ngOnInit () {
  }

  previewDoc (event) {
    this.selectedFile = event.target.files[ 0 ]
  }

  addDocument () {
    this.allFiles.push({
      'id': new Date().getTime(),
      'file': this.selectedFile,
      'isProofOfVaccine': this.isProofOfVaccine
    })
    this.selectedFile = null;
    this.isProofOfVaccine = false
  }

  removeDocument (id) {
    this.allFiles = this.allFiles.filter((e) => {
      return e.id != id;
    })
  }

  /////////////////////////////////

  updateAllData () {
    this.allFiles.forEach((item) => {

      this.uploadDocument(item)

      if (item.isProofOfVaccine) {
        //console.log(">>>>>> update member <<<<<<<<<")
         this.updateMember()
      }
    })

    this.updatePendingDoc()
  }

  uploadDocument (item) {
    const file: any = item.file;
    const finename = item.id + "_" + file.name
    const member_id = this.pendingDoc.member_id

    //  console.log("uploadDocument item: " + JSON.stringify(item))
    //  console.log("---------------------------------------------")
    //  this.updateDocument(item, "url")

    const fsRef: AngularFireStorageReference = this.fs.ref("documents/" + member_id + "/" + finename);
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateDocument(item, url)
        });
      }))
      .subscribe();

  }

  updateDocument (item: any, url: any) {
    let doc: Document = new Document();

    doc.approved = true; // por default - não faz sentido subir manualmente um doc errado!!
    doc.proofOfVaccine = false//item.isProofOfVaccine ? true : false;
    doc.date = new Date();
    doc.filename = item.file.name;
    doc.member_id = this.pendingDoc.member_id;
    doc.member_name = this.pendingDoc.member_name;
    doc.url = url;

    //  console.log("doc: " + JSON.stringify(doc))
    //  console.log("---------------------------------------------")

    this.db.collection('sbccv_documents').add(Object.assign({}, doc))
      .then(() => {
        console.log("document add")
      })
      .catch((err) => {
        console.log("erro upadate document: " + JSON.stringify(err))
      })

  }

  updateMember () {
    this._memberService.updateProofOfVaccine(this.pendingDoc.member_id, true)
      .then(() => {
        console.log("member updated")
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

  updatePendingDoc () {

    let pendingDoc: PendingDoc = new PendingDoc();

    pendingDoc.id = this.pendingDoc.id;
    pendingDoc.obs = "";

    pendingDoc.pending = false;
    pendingDoc.approved = true;

    pendingDoc.sent = false;
    
    console.log("pendingDoc: " + JSON.stringify(pendingDoc))
    console.log("---------------------------------------------")

    this._pendinDocService.update(pendingDoc)
      .then(() => {
        console.log("pendingDocs updated")
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })

  }
}
